module.exports = __webpack_public_path__ + "static/media/asiagreen-background.43654705.jpeg";